export type { PageProps } from "./Page";
export { Page } from "./Page";
